module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAYCAYAAAAGXva8AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAABZ0RVh0Q3JlYXRpb24gVGltZQAwOC8yMC8yMGXEmOUAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAA7klEQVRIie2VsQ3CMBBFXyIGYAMyAhvACPRuqN1A6Q6ocEuBa5BwzwYkGzAC2YANTEFAEFlUZxQJfmPry/K7O5/tbL09LIEF39Mm/zIQYNZ7zIxWWWqadT4A5KlBMf2hSdVrG9b5EhgJMiqj1fjV6Eam7ahSqBuZWucLoBBkXIxWl49QoAQGgtCaVhKx8paCwOh+sUaaAlNh8Jt+50X6HeizkR4fbKMaGBqtrtb5MbBD8BrlwD7iD4CJdf4InCSBwD4LIWCdHwL9xjxFFlbAUgB4NVqdsxDCmxsp89xodRQAPhVrpLoZV9zPVRQIcAN+Fj2Rit8TewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/my_icon.png
// module id = FHIP
// module chunks = 1